import { isPostcodeBlacklisted, isValidPostcode } from 'utils/validation';

export function isPostcodeValidAndAllowed(postcode?: string) {
  return isValidPostcode(postcode) || !isPostcodeBlacklisted(postcode);
}
